import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { ReverseComplementCalc } from "../components/ReverseComplementCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.revcomp_tool_name()}
        toolPath="/reverse-complement"
      />
      <SciHeader title={m.revcomp_h1()} intro={m.revcomp_intro()} />

      <ReverseComplementCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.revcomp_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.revcomp_ex1(), m.revcomp_ex2(), m.revcomp_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.revcomp_faq_q1(), a: m.revcomp_faq_a1() },
          { q: m.revcomp_faq_q2(), a: m.revcomp_faq_a2() },
          { q: m.revcomp_faq_q3(), a: m.revcomp_faq_a3() },
          { q: m.revcomp_faq_q4(), a: m.revcomp_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
